'use strict';

var ChartPerformanceFilterFactory = function ChartPerformanceFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketsFilterByCabinFactory', 'MarketsFilterByMarketFactory', 'MarketsFilterByPOSFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ChartPerformanceFilter() {
    DemandFilter.call(this, 'market-dashboard', 'dashboard-performance');
    this.registerFilters(injectedFilters);
  }
  ChartPerformanceFilter.prototype = Object.create(DemandFilter.prototype);
  ChartPerformanceFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return ChartPerformanceFilter;
};
ChartPerformanceFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ChartPerformanceFilterFactory;